import {Injectable} from '@angular/core';
import {Module, ModuleService} from '@shared/service/module.service';
import {AppConfigEnvironmentService} from '@shared/service/appconfig-environment.service';

enum TranslateContext {
	ADMINISTRATION = 'administration',
	AUTHORITY = 'authority',
	CLAIMS = 'claims',
	CONTRACT_CLOSING = 'contract-closing',
	AUTHORITY_ACCEPTANCE = 'authority-acceptance-modal',
	BREADCRUMBS_TITLES = 'breadcrumbs/titles/titles',
	BREADCRUMBS_LINK_ITEMS = 'breadcrumbs/link_items/link_items',
	HEADER = 'header/header',
	FLOTTA_POOL = 'flotta-pool/flotta-pool',
	AUTHORITY_FORM = 'authority-form',
	NOTIFICATION_CENTER = 'notification-center',
	DELIVERY = 'delivery',
	BOOKING_CALENDAR = 'booking-calendar',
	LOGISTICS = 'logistics'
}

@Injectable({
	providedIn: 'root'
})
export class TranslatePipeService {

	private translationValues: { [key: string]: { [key: string]: string } } = {};

	constructor(
		private moduleService: ModuleService,
		private appConfig: AppConfigEnvironmentService
	) {
		Object.keys(TranslateContext).forEach(key => this.setTranslationValues(TranslateContext[key]));
	}

	getMessages(module: string): { [key: string]: string } {
		if (!this.translationValues[module]) {
			this.setTranslationValues(module);
		}
		return this.translationValues[module];
	}

	private setTranslationValues(key: string): void {
		if (!this.translationValues[key]) {
			try {
				switch (key) {
					case TranslateContext.BREADCRUMBS_TITLES:
					case TranslateContext.BREADCRUMBS_LINK_ITEMS:
					case TranslateContext.HEADER:
						this.translationValues[key] = require(`../pipes/json/${key}.${this.appConfig.Environment.SERVER_DATE_LOCATION}.json`);
						break;
					case TranslateContext.FLOTTA_POOL:
						this.translationValues[key] = require(`../pipes/json/${key}.${this.appConfig.Environment.SERVER_DATE_LOCATION}.json`);
						break;
					case TranslateContext.AUTHORITY:
						try {
							this.translationValues[TranslateContext.AUTHORITY_ACCEPTANCE] = require(`../pipes/json/${key}/${TranslateContext.AUTHORITY_ACCEPTANCE}.${this.appConfig.Environment.SERVER_DATE_LOCATION}.json`);
							this.translationValues[TranslateContext.AUTHORITY_FORM] =
								require(`../pipes/json/form-values/${TranslateContext.AUTHORITY_FORM}-values/${TranslateContext.AUTHORITY_FORM}-values.${this.appConfig.Environment.SERVER_DATE_LOCATION}.json`);
						} catch (e) {
							this.translationValues[TranslateContext.AUTHORITY_ACCEPTANCE] = null;
						}
						this.translationValues[key] = require(`../pipes/json/${key}/${key}.${this.appConfig.Environment.SERVER_DATE_LOCATION}.json`);
						break;
					default:
						this.translationValues[key] = require(`../pipes/json/${key}/${key}.${this.appConfig.Environment.SERVER_DATE_LOCATION}.json`);
						break;
				}
			} catch (e) {
				this.translationValues[key] = null;
			}
		}
	}
}
